import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: localStorage.getItem("auth"),
  encryptionKeys: JSON.parse(localStorage.getItem("encryptionKeys")),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.auth = action.payload;
      localStorage.setItem("auth", state.auth);
    },
    setEncryptionKeys: (state, action) => {
      state.encryptionKeys = action.payload;
      localStorage.setItem("encryptionKeys", JSON.stringify(action.payload));
    },
  },
});

export const { setAuth, updateCamp, setEncryptionKeys } = authSlice.actions;

export default authSlice.reducer;
